module.exports = __webpack_public_path__ + "static/media/pecuaria-3.eadab607.jpg";